import './index.css'
import { useEffect } from 'react';
import React, { useState } from 'react';
import axios from 'axios';
import image from './constructionCompany.jpg'
import laying from './laying.jpg'
import { useNavigate } from 'react-router-dom';
import plasterImage from './plastring.jpg';
import sreedingImage from './screeding-icon.jpg';
import AOS from 'aos';
import moment from 'moment';
import 'aos/dist/aos.css';
import client1 from './HK.png';
import client2 from './bbr.png';
import client3 from './keong-hong.png';
import client4 from './united-tec-logo.png';
import client5 from './soilbuild_0.png';
import client6 from './kgl.png';
import client7 from './santarli.jpg';
import client8 from './dragas.jpg';
import showcase from './showcase1.jpg';

const HomePage = () => {
    const navigate = useNavigate();
    const [allProjects, setAllProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        AOS.init({
            duration: 1000,
            offset: 100,
            once: true
        });

        axios.get(process.env.REACT_APP_BASE_URL + '/api/projects')
            .then(res => {
                const sortedProjects = res.data
                    .map(project => ({
                        ...project,
                        startDate: moment(project.startDate).format('YYYY-MM-DD'),
                        endDate: moment(project.endDate).format('YYYY-MM-DD')
                    }))
                    .sort((a, b) => moment(b.endDate).toDate() - moment(a.endDate).toDate())
                    .slice(0, 3);
                setAllProjects(sortedProjects);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, []);

    const [formData, setFormData] = useState({
        name: '',
        emailAddress: '',
        message: '',
    });

    const currentDate = new Date();
    const [formErrors, setFormErrors] = useState({});
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [submitError, setSubmitError] = useState(false);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({ ...prev, [id]: value }));
        if (formErrors[id]) {
            setFormErrors(prev => ({ ...prev, [id]: '' }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = {};

        if (!formData.name.trim()) {
            errors.name = 'Name is required.';
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!formData.emailAddress.trim() || !emailRegex.test(formData.emailAddress)) {
            errors.emailAddress = 'Email Address is not valid.';
        }

        if (!formData.message.trim()) {
            errors.message = 'Message is required.';
        }

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        try {
            await axios.post(process.env.REACT_APP_BASE_URL + '/api/postQuery', formData);
            setFormData({ name: '', emailAddress: '', message: '' });
            setSubmitSuccess(true);
            setSubmitError(false);
            setTimeout(() => setSubmitSuccess(false), 5000);
        } catch (error) {
            setSubmitSuccess(false);
            setSubmitError(true);
            setTimeout(() => setSubmitError(false), 5000);
        }
    };

    const services = [
        { title: 'Plastering', image: plasterImage, desc: 'We do plastering to coat and protect walls, ceilings.' },
        { title: 'Screeding', image: sreedingImage, desc: 'Screed to form a smooth level surface for receiving a floor finishing.' },
        { title: 'Installation of Tiles', image: laying, desc: 'Professional worker in laying tiles, marble and granite etc in the interior of units.' }
    ];

    const stats = [
        { title: 'Projects', value: '20+', icon: '📊', gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
        { title: 'Tilers', value: '30+', icon: '👷', gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' },
        { title: 'Workers', value: '60+', icon: '👥', gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' },
        { title: 'Contract Value', value: '28M+', icon: '💰', gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)' }
    ];

    return (
        <div className="homepage-wrapper">
            {/* Hero Section */}
            <section className="hero-homepage">
                <div className="hero-overlay-homepage"></div>
                <img src={image} alt="Construction" className="hero-bg-image" />
                <div className="hero-content-homepage" data-aos="fade-up">
                    <h1 className="hero-title-homepage">HONG YUAN CONSTRUCTION</h1>
                    <p className="hero-subtitle-homepage">Building Dreams, Creating Future</p>
                    <div className="hero-buttons-homepage">
                        <button className="btn-homepage btn-primary-homepage" onClick={() => navigate('/projects')}>
                            View Projects
                        </button>
                        <button className="btn-homepage btn-secondary-homepage" onClick={() => document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' })}>
                            Contact Us
                        </button>
                    </div>
                </div>
            </section>

            {/* Profile Section */}
            <section className="section-homepage">
                <div className="container-homepage">
                    <h2 className="section-title-homepage" data-aos="fade-up">Our Profile</h2>
                    <div className="profile-grid-homepage">
                        <div className="profile-left-homepage" data-aos="fade-right">
                            <h3 className="company-name-homepage">HONG YUAN CONSTRUCTION PTE LTD</h3>
                            <p className="profile-text-homepage">
                                Hong Yuan is incorporated in 2012, we grow steadily and complete more than
                                <a href="/projects" className="link-homepage"> 20 big projects </a>
                                along the way, we have strongly-tied business relationships with over reputational clients, we also have showed our appreciation to the society through various charity events
                                <a href="/aboutus" className="link-homepage"> details</a>.
                            </p>
                        </div>
                        <div className="profile-right-homepage" data-aos="fade-left">
                            <div className="values-box-homepage">
                                <p className="values-intro-homepage">
                                    Our company has gained trust from many clients by upholding high standards.
                                    We prioritize and focus on three regulations:
                                </p>
                                <ul className="values-list-homepage">
                                    {['Professionalism', 'Responsibility', 'Quality'].map((item, index) => (
                                        <li key={index} className="value-item-homepage">
                                            <span className="value-icon-homepage">✓</span>
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                                <p className="values-quote-homepage">
                                    "We have earned a good reputation in construction for past years, we will continue to build singapore as dream home."
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Section */}
            <section className="section-homepage services-section-homepage">
                <div className="container-homepage">
                    <h2 className="section-title-homepage" data-aos="fade-up">Our Services</h2>
                    <p className="section-subtitle-homepage" data-aos="fade-up">Comprehensive construction solutions tailored to your needs</p>
                    <div className="services-grid-homepage">
                        {services.map((service, index) => (
                            <div key={index} className="service-card-homepage" data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="service-icon-wrapper-homepage">
                                    <img src={service.image} alt={service.title} className="service-icon-img-homepage" />
                                </div>
                                <h3 className="service-title-homepage">{service.title}</h3>
                                <p className="service-desc-homepage">{service.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Stats Section */}
            <section className="section-homepage stats-section-homepage">
                <div className="container-homepage">
                    <h2 className="section-title-homepage section-title-white-homepage" data-aos="fade-up">Our Achievement</h2>
                    <div className="stats-grid-homepage">
                        {stats.map((stat, index) => (
                            <div key={index} className="stat-card-homepage" data-aos="zoom-in" data-aos-delay={index * 100}>
                                <div className="stat-icon-homepage" style={{ background: stat.gradient }}>
                                    <span className="stat-emoji-homepage">{stat.icon}</span>
                                </div>
                                <h3 className="stat-value-homepage">{stat.value}</h3>
                                <p className="stat-title-homepage">{stat.title}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Clients Section */}
            <section className="section-homepage">
                <div className="container-homepage">
                    <h2 className="section-title-homepage" data-aos="fade-up">Our Clients</h2>
                    <p className="section-subtitle-homepage" data-aos="fade-up">
                        We have established a long-lasting cooperation with many reputational construction companies in Singapore
                    </p>
                    <div className="clients-grid-homepage">
                        {[client1, client2, client3, client4, client5, client6, client7, client8].map((client, index) => (
                            <div key={index} className="client-logo-homepage" data-aos="fade-up" data-aos-delay={index * 50}>
                                <img src={client} alt={`Client ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Projects Section */}
            <section className="section-homepage projects-section-homepage">
                <div className="container-homepage">
                    <h2 className="section-title-homepage" data-aos="fade-up">Recent Projects</h2>
                    {loading ? (
                        <div className="loading-homepage">
                            <div className="spinner-homepage"></div>
                        </div>
                    ) : (
                        <>
                            <div className="projects-grid-homepage">
                                {allProjects.map((project, index) => (
                                    <div key={index} className="project-card-homepage" data-aos="fade-up" data-aos-delay={index * 100}>
                                        <div className="project-image-wrapper-homepage">
                                            <img src={showcase} alt={project.title} className="project-image-homepage" />
                                            <div className="project-overlay-homepage">
                                                <a href={project.link} className="project-link-homepage">View Details</a>
                                            </div>
                                        </div>
                                        <div className="project-content-homepage">
                                            <h3 className="project-title-homepage">
                                                <a href={project.link}>{project.title}</a>
                                            </h3>
                                            <p className="project-desc-homepage">{project.description}</p>
                                            <div className="project-footer-homepage">
                                                <span className={`project-status-homepage ${new Date(project.endDate) < currentDate ? 'completed-homepage' : 'ongoing-homepage'}`}>
                                                    {new Date(project.endDate) < currentDate ? `Completed: ${project.endDate}` : 'Ongoing'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="text-center-homepage">
                                <button className="btn-homepage btn-outline-homepage" onClick={() => navigate('/projects')}>
                                    View All Projects →
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </section>

            {/* Contact Section */}
            <section id="contact-section" className="section-homepage">
                <div className="container-homepage">
                    <div className="contact-wrapper-homepage">
                        <div className="contact-image-homepage" data-aos="fade-right">
                            <img src="https://picsum.photos/600/700" alt="Contact" />
                        </div>
                        <div className="contact-form-wrapper-homepage" data-aos="fade-left">
                            <h2 className="contact-title-homepage">Wanna Talk to Us?</h2>
                            <p className="contact-subtitle-homepage">Get in touch with our team for your next project</p>
                            <form className="contact-form-homepage" onSubmit={handleSubmit}>
                                <div className="form-group-homepage">
                                    <input
                                        type="text"
                                        id="name"
                                        className={`form-input-homepage ${formErrors.name ? 'error-homepage' : ''}`}
                                        placeholder="Your Name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                    {formErrors.name && <span className="form-error-homepage">{formErrors.name}</span>}
                                </div>
                                <div className="form-group-homepage">
                                    <input
                                        type="email"
                                        id="emailAddress"
                                        className={`form-input-homepage ${formErrors.emailAddress ? 'error-homepage' : ''}`}
                                        placeholder="Your Email"
                                        value={formData.emailAddress}
                                        onChange={handleChange}
                                    />
                                    {formErrors.emailAddress && <span className="form-error-homepage">{formErrors.emailAddress}</span>}
                                </div>
                                <div className="form-group-homepage">
                                    <textarea
                                        id="message"
                                        className={`form-input-homepage form-textarea-homepage ${formErrors.message ? 'error-homepage' : ''}`}
                                        placeholder="Your Message"
                                        rows="5"
                                        value={formData.message}
                                        onChange={handleChange}
                                    />
                                    {formErrors.message && <span className="form-error-homepage">{formErrors.message}</span>}
                                </div>
                                {submitSuccess && (
                                    <div className="alert-homepage alert-success-homepage">
                                        ✓ We have received your inquiry! We'll get back to you soon.
                                    </div>
                                )}
                                {submitError && (
                                    <div className="alert-homepage alert-error-homepage">
                                        ✗ Error sending message! Please try again.
                                    </div>
                                )}
                                <button type="submit" className="btn-homepage btn-primary-homepage btn-full-homepage">
                                    Send Message
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="footer-homepage">
                <div className="container-homepage">
                    <small>
                        {new Date().getFullYear()} Copyright © Hong Yuan Construction Pte Ltd, UEN:200922798D
                    </small>
                </div>
            </footer>
        </div>
    );
};

export default HomePage;
